import React, { Component } from 'react';
import Controller from './Controller';
import Map from './Map';
import './index.css';



class MarketMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPrice:true,
      searchResult:null
    }
    this.showPrice = this.showPrice.bind(this);
    this.showNA = this.showNA.bind(this);
    this.handleSelectSearchItem = this.handleSelectSearchItem.bind(this);
  }

  showPrice(showPrice){
    this.setState({showPrice})
  }

  showNA(showNA){
    this.props.hendleShowNA(showNA);
  }

  handleSelectSearchItem(searchResult){
    this.setState({searchResult})
  }

  render() {
    const { lang, dataSource } = this.props;
    const { showPrice, searchResult } = this.state;
    //console.log('MarketMap searchResult', searchResult)
    return (
      <div className='sc-market-map-main-container'>
        <Controller dataSource={dataSource} onSelectSearchItem={this.handleSelectSearchItem}
          lang={lang} showPrice={this.showPrice} showNA={this.showNA}/>
        <Map dataSource={dataSource} showPrice={showPrice} searchResult={searchResult}/>
      </div>
    );
  }
}




export default MarketMap;

